function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "250",
  height: "160"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M165 71v-8a40 40 0 00-80 0v8a8 8 0 00-8 8v48a8 8 0 008 8h80a8 8 0 008-8V79a8 8 0 00-8-8zm-32 32a8 8 0 01-16 0v-8a8 8 0 0116 0zm16-32h-48v-8a24 24 0 0148 0z",
  fill: "#f5f6f8",
  id: "_16x16",
  "data-name": "16x16",
  opacity: ".25"
}));